<div class="input-number">
    <a class="menos" (click)="onInput(value-1)"
        [ngClass]="{'disabled':+value === +min}"></a>
    <input type="number" [value]="value" [disabled]="isDisabled"
        (input)="onInput($event.target.value)" (keyup)="validateLimits()">
    <a class="mas" (click)="onInput(value+1)"
        [ngClass]="{'disabled':+value === +max}"></a>
</div>